<template>
  <div class="view pa24">
    <el-button
      type="primary"
      :disabled="!hasPermi"
      @click="
        centerDialogVisible = true;
        bEdit = false;
      "
      >添加优惠券</el-button
    >
    <commonTable
      :tableData="tableData"
      :loading="loading"
      @handleSizeChange="handleSizeChange"
      @handleCurrentChange="handleCurrentChange"
      :currentPage="currentPage"
      :total="total"
    >
      <template v-slot:table>
        <el-table-column
          width="50"
          type="index"
          align="center"
          label="序号"
          show-overflow-tooltip
        />
        <el-table-column prop="name" align="center" label="优惠卷名称" show-overflow-tooltip/>
        <el-table-column prop="goodsTypeName" align="center" label="使用范围" show-overflow-tooltip>
          <template slot-scope="scope">
            <span>{{ scope.row.goodsTypeName }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="grantModeText" align="center" label="发放方式" show-overflow-tooltip>
          <template slot-scope="scope">
            <template v-if="scope.row.grantMode == 4">
              优惠码发放
            </template>
            <span v-else>{{ scope.row.grantModeText }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="grantObjectText"
          align="center"
          label="发放对象"
          width="200"
        >
          <template slot-scope="scope">
            <!-- <span>{{ scope.row.grantObjectText }}</span> -->
            <el-button size="mini" @click="lookUser(scope.row.couponId)">查看</el-button>
          </template>
        </el-table-column>
        <el-table-column
          prop="receiveNum"
          show-overflow-tooltip
          align="center"
          label="领取数量（张）"
        >
          <template slot-scope="scope">
            <span style="color: #51cdcb">{{ scope.row.receiveNum }}张</span>
          </template>
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          prop="couponTypeText"
          align="center"
          label="优惠卷类型"
        />
        <el-table-column prop="address" align="center" show-overflow-tooltip label="优惠卷折扣/金额">
          <template slot-scope="scope">
            <span style="color: #fd634e" v-if="scope.row.couponType == 1"
              >{{ scope.row.couponFaceValue }}元</span
            >
            <span style="color: #fd634e" v-if="scope.row.couponType == 2"
              >{{ scope.row.couponDiscount }}折</span
            >
          </template>
        </el-table-column>
        <el-table-column prop="minAmount" align="center" show-overflow-tooltip label="最低消费金额">
          <template slot-scope="scope">
            <span>{{ scope.row.minAmount }}元</span>
          </template>
        </el-table-column>
        <el-table-column prop="couponNum" align="center" show-overflow-tooltip label="发券/剩余">
          <template slot-scope="scope" >
            <div v-if="scope.row.codeGenModel && scope.row.codeGenModel !== 2">
<span
              style="color:#51CBCD"
              >{{
                scope.row.couponNum === 0
                  ? "不限量"
                  : scope.row.couponNum + "/"
              }}</span>
              <span>{{ scope.row.couponNum - scope.row.receiveNum }}</span>
            </div>
            <div v-else>
              <span>不限量</span> 
            </div>
            
          </template>

        </el-table-column>
        <el-table-column align="center" show-overflow-tooltip label="发放日期" width="200">
          <template slot-scope="scope" v-if="scope.row.grantStartTime && scope.row.grantEndTime">
            <span
              >{{ scope.row.grantStartTime }}到{{
                scope.row.grantEndTime
              }}</span
            >
          </template>
        </el-table-column>
        <el-table-column align="center" label="有效日期" show-overflow-tooltip width="200">
          <template slot-scope="scope">
            <span
              >{{ scope.row.effectiveStartTime }}到{{
                scope.row.effectiveEndTime
              }}</span
            >
          </template>
        </el-table-column>
        <el-table-column
          prop="pubState"
          align="center"
          label="发布状态"
          width="140"
        >
          <template slot-scope="scope">
            <el-switch
              @change="(e) => pubStateChange(e, scope.row)"
              :value="scope.row.pubState == 2 ? true : false"
              active-text="启用"
              inactive-text="禁用"
            >
            </el-switch>
          </template>
        </el-table-column>
        <el-table-column align="center" width="260" label="操作">
          <template slot-scope="scope">
            <el-button class="mr10" type="text" @click="detail(scope.row.couponId)"
              >领取记录</el-button
            >
            <el-button class="mr10" type="text" @click="edit(scope.row)" :disabled="!hasPermi"
              >编辑</el-button
            >
            <!-- 优惠码发放显示"优惠码"，其他显示"指定对象" -->
            <el-button v-if="scope.row.grantMode == 4" class="mr10" type="text" @click="viewCouponCodes(scope.row)">优惠码</el-button>
            <el-button v-else class="mr10" type="text" @click="addWinUser(scope.row.couponId)">指定对象</el-button>
            <customPopconfirm
              confirm-button-text="确定"
              cancel-button-text="取消"
              @confirm="del(scope.row.couponId)"
              icon="el-icon-info"
              icon-color="red"
              title="确定要删除这个优惠券吗？" >
              <el-button slot="reference" style="color: #fd634e" type="text" :disabled="!hasPermi"
                >删除</el-button
              >
            </customPopconfirm>
          </template>
        </el-table-column>
      </template>
    </commonTable>
    <el-dialog
      title="添加优惠券"
      :visible.sync="centerDialogVisible"
      :modal-append-to-body="false"
      :destroy-on-close="true"
      :close-on-click-modal="false"
      width="40%"
    >
      <addCoupon
        :bEdit="bEdit"
        @submitForm="submitForm"
        @onConfirmEdit="onConfirmEdit"
        ref="addCoupon"
      />
      <span slot="footer" class="dialog-footer">
        <el-button
          @click="
            centerDialogVisible = false;
            bEdit = false;
          "
          >取 消</el-button
        >
        <el-button type="primary" @click="determine">确 定</el-button>
      </span>
    </el-dialog>
    <!--指定人发放优惠券-->
    <el-dialog
      title="指定对象"
      :visible.sync="winUserDialogVisible"
      :modal-append-to-body="false"
      :destroy-on-close="true"
      :close-on-click-modal="false"
      width="40%"
    >
      <el-form :model="winUserForm" :rules="winUserFormRules" ref="winUserForm" label-width="auto">
        <el-form-item label="用户手机号" prop="phone">
          <el-input class="w220" v-model="winUserForm.phone"></el-input>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button
          @click="
            winUserDialogVisible = false;
            bEdit = false;
          "
          >取 消</el-button
        >
        <el-button type="primary" @click="handleAddWinUser">确 定</el-button>
      </span>
    </el-dialog>
    <!--指定人列表-->
    <el-dialog
      title="指定人列表"
      :visible.sync="winTableVisible"
      :modal-append-to-body="false"
      :destroy-on-close="true"
      :close-on-click-modal="false"
      width="40%"
    >
     <commonTable
      :tableData="winTable"
      :loading="loading"
      @handleSizeChange="handleSizeChange2"
      @handleCurrentChange="handleCurrentChange2"
      :currentPage="currentPage"
      :total="winTotal"
    >
      <template v-slot:table>
        <el-table-column
          width="50"
          type="index"
          align="center"
          label="序号"
          show-overflow-tooltip
        />
        <el-table-column prop="createTime" align="center" label="创建时间" show-overflow-tooltip/>
        <el-table-column prop="status" align="center" label="是否领取" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ scope.row.status == 1 ? '已领取': '未领取' }}
          </template>
        </el-table-column>
        <el-table-column prop="phone" align="center" label="手机号" show-overflow-tooltip/>
         <el-table-column align="center" label="编辑" show-overflow-tooltip>
           <template slot-scope="scope">
             <el-button type="text" @click="delWinUser(scope.row)">删除</el-button>
           </template>
         </el-table-column>
      </template>
    </commonTable>
    </el-dialog>
    <!--优惠码列表-->
    <el-dialog
      title="优惠码列表"
      :visible.sync="couponCodeDialogVisible"
      :modal-append-to-body="false"
      :destroy-on-close="true"
      :close-on-click-modal="false"
      width="60%"
    >
      <div style="margin-bottom: 15px; display: flex; justify-content: space-between; align-items: center;">
        <span style="color: #666;">共 {{ couponCodeTotal }} 个优惠码</span>
        <el-button type="primary" @click="exportCouponCode">导出</el-button>
        <!-- <el-select v-model="couponCodeStatus" placeholder="全部状态" size="small" style="width: 120px;" @change="handleCodeStatusChange">
          <el-option label="全部" value="" />
          <el-option label="未使用" value="1" />
          <el-option label="已使用" value="2" />
          <el-option label="已过期" value="3" />
        </el-select> -->
      </div>
      <commonTable
        :tableData="couponCodeList"
        :loading="couponCodeLoading"
        @handleSizeChange="handleCodeSizeChange"
        @handleCurrentChange="handleCodeCurrentChange"
        :currentPage="couponCodePage"
        :total="couponCodeTotal"
      >
        <template v-slot:table>
          <el-table-column
            width="60"
            type="index"
            align="center"
            label="序号"
          />
          <el-table-column prop="code" align="center" label="优惠码">
            <template slot-scope="scope">
              <span style="font-family: monospace; letter-spacing: 1px;">{{ scope.row.code }}</span>
              <el-button type="text" size="mini" style="margin-left: 8px;" @click="copyCouponCode(scope.row.code)">复制</el-button>
            </template>
          </el-table-column>
          <el-table-column prop="status" align="center" label="状态" width="100">
            <template slot-scope="scope">
              <el-tag :type="scope.row.status == 1 ? 'success' : scope.row.status == 2 ? 'info' : 'danger'" size="mini">
                {{ scope.row.status == 1 ? '未兑换' : scope.row.status == 2 ? '已兑换' : '已过期' }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="useTime" align="center" label="兑换时间" width="180">
            <template slot-scope="scope">
              {{ scope.row.dhTime || '-' }}
            </template>
          </el-table-column>
          <el-table-column prop="phone" align="center" label="使用用户" width="130">
            <template slot-scope="scope">
              {{ scope.row.nickName || '-' }}
            </template>
          </el-table-column>
        </template>
      </commonTable>
    </el-dialog>
  </div>
</template>

<script>
import commonTable from "@/components/common/commonTable";
import customPopconfirm from "@/components/common/customPopconfirm";
import { crmPcPageList, updState, add, del, upd, fetchAddWinCoupon, fetchWinCouponList, fetchDeleteCouponList, fetchCouponCodeList } from "@/api/coupon";
import addCoupon from "./addCoupon";
import {formatAmount} from "@/utils/utils";

export default {
  name: "couponList",
  components: {
    commonTable,
    addCoupon,
    customPopconfirm
  },
  data() {
    return {
      hasPermi: true,
      tableData: [],
      currentPage: 1, //当前页
      pageSize: 10, //显示条数
      loading: false, //表格加载
      total: 0, //总条数
      centerDialogVisible: false,
      bEdit: false, //编辑
      couponId: "", //编辑时需要传的id
      companyId: "", //编辑时需要传的id

      winUserDialogVisible: false,

      winUserForm: {
        phone: '',
      },
      winUserFormRules: {
        phone: [
          { required: true, message: "请输入用户手机号" },
          { pattern: /^1[3456789]\d{9}$/, message: '请输入正确手机号' }
        ]
      },
      winPageNum: 1,
      winPageSize: 10,
      winTable: [],
      winTotal: 0,
      winTableVisible: false,
      
      // 优惠码相关
      couponCodeDialogVisible: false,
      currentCoupon: null,
      couponCodeList: [],
      couponCodeLoading: false,
      couponCodePage: 1,
      couponCodePageSize: 10,
      couponCodeTotal: 0,
      couponCodeStatus: '' // 优惠码状态过滤：'' 全部 / 1 未使用 / 2 已使用 / 3 已过期
    };
  },
  created() {
    this.crmPcPageList();
    if(JSON.parse(localStorage.getItem('isSourceAdmin'))) {
      this.hasPermi = false
    }
  },
  methods: {
    // 前端自己导出，接口fetchCouponCodeList，pageSize:9999返回全部，然后导出excel
    async exportCouponCode() {
      if (!this.currentCoupon?.couponId) {
        this.$message.warning('请先选择优惠券')
        return
      }
      try {
        this.couponCodeLoading = true
        const params = {
          couponId: this.currentCoupon.couponId,
          pageNum: 1,
          pageSize: 9999
        }
        if (this.couponCodeStatus) params.status = this.couponCodeStatus
        const res = await fetchCouponCodeList(params)
        if (res && res.code === 200) {
          const list = (res.data && res.data.list) || []
          const tHeader = ['序号', '优惠码', '状态', '兑换时间', '使用用户']
          const data = list.map((item, index) => [
            index + 1,
            item.code || '',
            item.status == 1 ? '未兑换' : item.status == 2 ? '已兑换' : '已过期',
            item.dhTime || '-',
            item.nickName || '-'
          ])
          const tname = '优惠码_' + this.currentCoupon.name + '_' + new Date().getTime() + '.xlsx'
          require.ensure([], () => {
            const { export_json_to_excel } = require('@/excel/Export2Excel.js')
            export_json_to_excel(tHeader, data, tname)
          })
        } else {
          this.$message.error('获取优惠码列表失败')
        }
      } catch (e) {
        console.error(e)
        this.$message.error(e.message || '导出失败')
      } finally {
        this.couponCodeLoading = false
      }
    },
    /***指定优惠券对象 */
    addWinUser(couponId) {
      this.winUserDialogVisible = true
      this.couponId = couponId
    },
    /** 指定优惠券弹窗确定*/
    handleAddWinUser() {
       this.$refs.winUserForm.validate((valid) => {
         if (valid) {
           let params = {
             couponId: this.couponId,
             phone: this.winUserForm.phone
           }
           fetchAddWinCoupon(params).then(res => {
             if(res.code === 200) {
              this.$message({
                type: "success",
                message: "操作成功",
              });
              this.closeWinUserDialog()
             }else{
               this.$message({
                type: "error",
                message: "操作失败",
              });
             }
           })
         }
       })
    },
    closeWinUserDialog() {
      this.winUserDialogVisible = false
      this.$refs.winUserForm.resetFields();
      this.couponId = ""
      this.crmPcPageList()
    },
    lookUser(couponId) {
      this.winPageNum = 1,
      this.couponId = couponId
      this.getWinList()
      var that = this
      setTimeout(function(){
          that.winTableVisible = true
      },0)
    },
    getWinList() {
      let params = {
        couponId: this.couponId,
        pageNum: this.winPageNum,
        pageSize: this.winPageSize
      }
      fetchWinCouponList(params).then(res => {
        if(res.code === 200) {
          this.winTable = res.data.list
          this.winTotal = res.data.total
        }
      })
    },
    handleSizeChange2(val) {
      this.winPageSize = val;
      this.getWinList();
    },
    handleCurrentChange2(val) {
      this.winPageNum = val;
      this.getWinList();
    },
    delWinUser(row) {
      let params = {
        ids: [row.id]
      }
      fetchDeleteCouponList(params).then(res => {
        if(res.code === 200) {
          this.$message({
            type: "success",
            message: "操作成功",
          });
          this.winTableVisible = false
        }
      })
    },
    /**@method  优惠券列表*/
    async crmPcPageList() {
      let data = {
        pageSize: this.pageSize,
        pageNum: this.currentPage,
      };
      try {
        this.loading = true;
        const result = await crmPcPageList(data);
        this.loading = false;
        const { total, list } = result?.data;
        list.forEach(item=>{
          item.couponFaceValue=formatAmount(item.couponFaceValue)
          item.minAmount=formatAmount(item.minAmount)
        })
        this.tableData = list;
        this.total = total;
      } catch (error) {
        this.loading = false;
        console.log(error);
      }
    },
    /**@method 发布状态 */
    async pubStateChange(e, { couponId }) {
      let data = {
        couponId,
        pubState: e ? 2 : 1,
      };
      await updState(data);
      await this.crmPcPageList();
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.crmPcPageList();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.crmPcPageList();
    },
    determine() {
      this.$refs.addCoupon.submitForm();
    },
    /**
     * @method 发布优惠券
     * @param {Object} val - 表单值
     */
    async submitForm(val) {
      
      if(val.rangeType == 1) {
        val.goodstypeId = 0
        val.itemId = ""

      }else if(val.rangeType == 2) {

        val.goodstypeId = 2
        val.itemId = val.goodtypeId

      }else if(val.rangeType == 3){

        val.goodstypeId = 3
        val.itemId = val.goodsId
      }
      delete val.goodtypeId
      delete val.goodsId
      delete val.rangeType;
      let data = {
        ...val,
        couponFaceValue: val.couponFaceValue*100,
        minAmount: val.minAmount*100,
        // goodstypeId: val.goodstypeId == "" ? 0 : val.goodstypeId,
        // goodstypeIds: 0,
        pubState: val.pubState ? 2 : 1,
        effectiveStartTime: val.effectiveDate[0],
        effectiveEndTime: val.effectiveDate[1],
      };
      // 首页赠券/后台发放：拆分发券日期；优惠码发放才不传 grantStartTime/EndTime
      if (val.grantMode !== '4' && val.grantTime && val.grantTime.length === 2) {
        data.grantStartTime = val.grantTime[0]
        data.grantEndTime = val.grantTime[1]
      } else {
        delete data.grantTime
      }
      delete data.grantTime;
      // 非优惠码发放：移除优惠码相关参数；随机生成时移除指定优惠码
      if (val.grantMode !== '4') {
        delete data.codeGenModel
        delete data.couponCode
        delete data.useMaxNum
      } else if (val.codeGenModel !== '2') {
        delete data.couponCode
      }
      try {
        await add(data, { showLoading: true });
        this.centerDialogVisible = false;
        await this.crmPcPageList();
      } catch (error) {
        console.log(error);
         this.$message({
          message: error.message || "失败",
          type: "warning",
        });
      }
    },
    /**
     * @method 删除优惠券
     * @param {String} val - id
     */
    async del(val) {
      try {
        await del({ couponId: val });
        await this.crmPcPageList();
      } catch (error) {
        console.log(error);
        this.$message({
          message: error.message || "请选择需求",
          type: "warning",
        });
      }
    },
    /**
     * @method 领取记录
     * @param {String} val - 优惠券id
     */
    detail(id){
      this.$router.push('/marketing/coupon/detailCoupon?id='+ id)
    },


    /**@method 编辑
     * @param {Object} val - 当前点击行的值
     */
    edit(val) {
      this.centerDialogVisible = true;
      this.bEdit = true;
      console.log(val);
      const {
        name,
        minAmount,
        couponFaceValue,
        couponType,
        effectiveStartTime,
        effectiveEndTime,
        grantStartTime,
        grantEndTime,
        grantMode,
        couponNum,
        maxUser,
        pubState,
        couponId,
        companyId,
        couponDiscount,
        couponCode,
        codeGenModel,
        useMaxNum,
      } = val;
      this.couponId = couponId;
      this.companyId = companyId;
      let data = {
        name,
        minAmount,
        couponType: String(couponType),
        couponFaceValue,
        effectiveDate: [effectiveStartTime, effectiveEndTime],
        grantMode: String(grantMode),
        couponNum,
        maxUser: maxUser || '',
        // 优惠码发放相关字段回填
        codeGenModel: codeGenModel != null ? String(codeGenModel) : '1',
        couponCode: couponCode || '',
        useMaxNum: useMaxNum != null ? useMaxNum : 1,
        pubState: pubState == 1 ? false : true,
        goodstypeId: val.goodstypeId ? val.goodstypeId : 0,
        couponDiscount,
        rangeType: String(val.goodstypeId),
      };
      // 非优惠码发放才回填发券日期，优惠码发放时清空避免切换时残留
      if (grantMode != 4 && grantStartTime && grantEndTime) {
        data.grantTime = [grantStartTime, grantEndTime]
      } else {
        data.grantTime = ""
      }
      if(val.goodstypeId == 0) {
        data.goodtypeId = ""
        data.goodsId = ""
        data.rangeType = '1'
      }else if(val.goodstypeId == 2) {
        data.goodtypeId = val.itemId
        data.goodsId = ""
        data.rangeType = '2'
      } else if(val.goodstypeId == 3){
        data.goodsId = val.itemId
        data.goodtypeId = ""
        data.rangeType = '3'
      }
      this.$nextTick(() => {
        this.$refs.addCoupon.ruleForm = data;
      });
    },
    /**@method 确定编辑 */
    async onConfirmEdit(val) {
      if(val.rangeType == 1) {
        val.goodstypeId = 0
        val.itemId = ""

      }else if(val.rangeType == 2) {

        val.goodstypeId = 2
        val.itemId = val.goodtypeId

      }else if(val.rangeType == 3){

        val.goodstypeId = 3
        val.itemId = val.goodsId
      }
      delete val.goodtypeId
      delete val.goodsId
      delete val.rangeType;

      let data = {
        ...val,
        couponFaceValue: val.couponFaceValue*100,
        minAmount: val.minAmount*100,
        couponId: this.couponId,
        companyId: this.companyId,
        goodstypeId: val.goodstypeId ? val.goodstypeId : 0,
        goodstypeIds: 0,
        pubState: val.pubState ? 2 : 1,
        effectiveStartTime: val.effectiveDate[0],
        effectiveEndTime: val.effectiveDate[1],
      };
      // 首页赠券/后台发放：拆分发券日期；优惠码发放才不传 grantStartTime/EndTime
      if (val.grantMode !== '4' && val.grantTime && val.grantTime.length === 2) {
        data.grantStartTime = val.grantTime[0]
        data.grantEndTime = val.grantTime[1]
      }
      delete data.grantTime;
      // 非优惠码发放：移除优惠码相关参数；随机生成时移除指定优惠码
      if (val.grantMode !== '4') {
        delete data.codeGenModel
        delete data.couponCode
        delete data.useMaxNum
      } else if (val.codeGenModel !== '2') {
        delete data.couponCode
      }
      console.log(data);
      try {
        await upd(data, { showLoading: true });
        this.centerDialogVisible = false;
        this.bEdit = false;
        await this.crmPcPageList();
      } catch (error) {
        console.log(error);
      }
    },
    /** 查看优惠码（仅优惠码发放 grantMode=4） */
    viewCouponCodes(row) {
      this.currentCoupon = row
      this.couponCodePage = 1
      this.couponCodeStatus = ''
      this.couponCodeDialogVisible = true
      this.getCouponCodeList()
    },
    async getCouponCodeList() {
      if (!this.currentCoupon?.couponId) return
      this.couponCodeLoading = true
      try {
        const params = {
          couponId: this.currentCoupon.couponId,
          pageNum: this.couponCodePage,
          pageSize: this.couponCodePageSize
        }
        if (this.couponCodeStatus) params.status = this.couponCodeStatus
        const res = await fetchCouponCodeList(params)
        if (res && res.code === 200) {
          this.couponCodeList = (res.data && res.data.list) || []
          this.couponCodeTotal = (res.data && res.data.total) || 0
        }
      } catch (e) {
        console.error(e)
        this.$message({ type: 'error', message: e.message || '获取优惠码列表失败' })
      } finally {
        this.couponCodeLoading = false
      }
    },
    handleCodeSizeChange(val) {
      this.couponCodePageSize = val
      this.couponCodePage = 1
      this.getCouponCodeList()
    },
    handleCodeCurrentChange(val) {
      this.couponCodePage = val
      this.getCouponCodeList()
    },
    handleCodeStatusChange() {
      this.couponCodePage = 1
      this.getCouponCodeList()
    },
    copyCouponCode(code) {
      if (!code) return this.$message.warning('暂无可复制的优惠码')
      const input = document.createElement('textarea')
      input.value = code
      input.style.position = 'fixed'
      input.style.top = '-9999px'
      document.body.appendChild(input)
      input.select()
      try {
        document.execCommand('copy')
        this.$message.success('已复制到剪贴板')
      } catch (e) {
        this.$message.error('复制失败，请手动复制')
      } finally {
        document.body.removeChild(input)
      }
    }
  },
};
</script>

<style lang="scss" scoped>
</style>
